module.exports = __webpack_public_path__ + "public/images/writing-skills.a218498d5248ecc923e55a5c423e7558.jpg";